import { Box, SelectChangeEvent, MenuItem, FormControl, TextField } from '@mui/material';
import SweepSelect from '../../../common/SweepSelect';
import { AutomationActionRowProps } from '../types';
import { getRelativeDateList } from '../utils/getRelativeDateList';
import { useSweepFieldsInfo } from '../../../../sweep-fields/useSweepFieldsInfo';

export const RelativeSelect = ({
  readonly,
  onChange,
  _field,
}: Pick<AutomationActionRowProps, 'readonly' | 'onChange'> & { _field: AutomationActionField }) => {
  const { getSalesforceDisplayTypeFromFieldId: getSalesforceDisplayTypeFromFieldId } =
    useSweepFieldsInfo();
  if (typeof _field.value !== 'string' && !(_field.value instanceof String)) return null;
  const fieldValue = _field.value as string;

  const relativeDateList = getRelativeDateList(
    getSalesforceDisplayTypeFromFieldId(_field._fieldIds),
  );

  return (
    <Box sx={{ display: 'flex', width: '100%', gap: '8px' }}>
      <Box sx={{ flexGrow: 1 }}>
        <SweepSelect
          FormControlProps={{
            sx: { width: '100%' },
          }}
          SelectProps={{
            disabled: readonly,
            placeholder: 'Choose Option',
            value: _field.value ?? '',
            onChange: (event: SelectChangeEvent<unknown>) => {
              const val = event.target.value;
              onChange({
                ..._field,
                value: val as string,
              });
            },
            renderValue: (val: any) => {
              const nonNumeric = val.match(/\D/g).join('');
              const output = relativeDateList.find((d) => d.value === nonNumeric);
              if (output) {
                return output.description;
              }
            },
          }}
        >
          {relativeDateList.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.description}
            </MenuItem>
          ))}
        </SweepSelect>
      </Box>

      {_field.value && _field.value !== 'today' && _field.value !== 'now' && (
        <FormControl sx={{ flexShrink: 0 }}>
          <TextField
            disabled={readonly}
            variant="outlined"
            type={'number'}
            value={_field.value.split('-')[1] || _field.value.split('+')[1]}
            onChange={(event) => {
              const nonNumericPrefix = fieldValue.match(/\D/g)?.join('');
              onChange({
                ..._field,
                value: nonNumericPrefix + event.target.value,
              });
            }}
            InputProps={{
              inputProps: {
                min: 1,
              },
              sx: {
                padding: '8px 6px',
                height: '39px',
                width: '90px',
              },
            }}
            placeholder={'Days'}
          />
        </FormControl>
      )}
    </Box>
  );
};
